import { EmptyCalendarState } from '@/components/empty-calendar-state';

export const NoClassesYet = () => (
  <EmptyCalendarState
    className="py-6"
    title="No classes yet"
    description="The studio has not added any classes yet. Check back soon."
  />
);
